import React from "react";
import missionImg from "../../images/Shape.png";
import { IMAGE_URL } from "../../constants";
const MissionStatementAbout = ({ card }) => {
  return (
    <div className="col" key={card}>
      <div
        className="card"
        style={{
          backgroundImage: `url(${missionImg})`,
          backgroundSize: "cover",
          borderRadius: "10px",
          height: "100%",
        }}
      >
        <div
          className="card-body d-flex flex-column justify-content-start align-items-center"
        //   style={{ rowGap: "30px", paddingTop: "5rem" }}
        >
          <img
            // src={`/assets/images/${cardNumber.img}`}
            src={`${IMAGE_URL}${card.media[0]}`}
            alt=""
          />
          <h5 className="card-title mt-2" style={{color:"#AF9763"}}>{card.title}</h5>
          <div
            className="cardDescription"
            dangerouslySetInnerHTML={{
              __html: card.description,
            }}
          ></div>
        </div>
      </div>
    </div>
  );
};

export default MissionStatementAbout;



// WEBPACK FOOTER //
// ./src/component/frontend/MissionStatementAbout.js